<template>
  <div class="form-content">
    <h2>{{ $route.meta.title }}</h2>

    <el-form
      ref="newUserForm"
      :rules="defaultOption.userForm.rules"
      :inline="true"
      :model="formData"
      label-width="8em"
    >
      <div class="border-container">
        <div class="partial-info-section">
          <h2 class="title"><span>乘客資料</span></h2>

          <div class="table-responsive">
            <table class="table table-hover">
              <tbody>
                <tr>
                  <td>姓名</td>
                  <td>
                    <el-input
                      placeholder="請輸入"
                      v-model="formData.name"
                    ></el-input>
                  </td>
                </tr>
                <tr>
                  <td>聯絡人</td>
                  <td>
                    <el-input
                      placeholder="請輸入"
                      v-model="formData.contactPerson"
                    ></el-input>
                  </td>
                </tr>
                <tr>
                  <td>區域類型</td>
                  <td>
                    <el-select
                      :value="String(formData.areaType)"
                      @input="$set(formData, 'areaType', $event)"
                      placeholder="Select"
                    >
                      <el-option
                        v-for="item in defaultOption.areaTypeOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </td>
                </tr>
                <tr>
                  <td>身份別</td>
                  <td>
                    <el-select
                      :value="String(formData.class)"
                      @input="$set(formData, 'class', $event)"
                      placeholder="Select"
                    >
                      <el-option
                        v-for="item in defaultOption.userClassOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>

                    <span style="margin-left: 50px">
                      社區式接送
                      <el-switch v-model="formData.deliveryMethod"></el-switch>
                      <el-input
                        v-show="formData.deliveryMethod"
                        type="number"
                        placeholder="請輸入上限次數"
                        v-model="formData.communityShuttleFrequency"
                        style="width: auto"
                      ></el-input>
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>手機一</td>
                  <td>
                    <el-input
                      placeholder="請輸入"
                      v-model="formData.firstMobilePhoneNumber"
                    ></el-input>
                  </td>
                </tr>

                <tr>
                  <td>住家電話</td>
                  <td>
                    <el-input
                      placeholder="請輸入"
                      v-model="formData.telephoneNumber"
                    ></el-input>
                  </td>
                </tr>

                <tr>
                  <td>手機二</td>
                  <td>
                    <el-input
                      placeholder="請輸入"
                      v-model="formData.secondMobilePhoneNumber"
                    ></el-input>
                  </td>
                </tr>

                <tr>
                  <td>行政區</td>
                  <td>
                    <DistrictSelector
                      :value="formData.area"
                      @input="$set(formData, 'area', $event.districtName)"
                      flatten
                      :cities="['高雄市']"
                    />
                  </td>
                </tr>

                <tr>
                  <td>身分證</td>
                  <td>
                    <el-input
                      placeholder="請輸入"
                      v-model="formData.identityCode"
                    ></el-input>
                  </td>
                </tr>

                <!-- 住家地址, 備註-->
                <tr>
                  <td>住家地址</td>
                  <td>
                    <el-autocomplete
                      class="block"
                      v-model="formData.address"
                      :fetch-suggestions="handleTypeIn"
                      placeholder="請輸入地址"
                      highlight-first-item
                      popper-class="wider-autocomplete"
                      @select="handleLocation('address', $event)"
                    ></el-autocomplete>
                    <span>
                      GPS:
                      {{ (formData.gps && formData.gps.join(', ')) || '--' }}
                    </span>
                  </td>
                </tr>

                <tr>
                  <td>偏好服務</td>
                  <td>
                    <el-form-item>
                      <el-checkbox-group v-model="formData.service">
                        <el-checkbox
                          v-for="service in teamAvailableServices"
                          :label="service.teamServiceId"
                          :key="`service-${service.teamServiceId}`"
                        >
                          {{ service.name }}
                        </el-checkbox>
                      </el-checkbox-group>
                    </el-form-item>
                  </td>
                </tr>

                <tr>
                  <td>備註</td>
                  <td>
                    <el-input
                      type="textarea"
                      autosize
                      placeholder="請輸入"
                      v-model="formData.note"
                    ></el-input>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <el-row>
            <el-col :push="4" :span="20">
              <el-form-item label="權限開通">
                <el-switch v-model="formData.authority"></el-switch>
              </el-form-item>

              <el-form-item label="免驗證身份">
                <el-switch
                  v-model="formData.verification"
                  :active-value="false"
                  :inactive-value="true"
                ></el-switch>
              </el-form-item>
            </el-col>

            <!-- 用戶頭像 -->
            <el-col :push="4" :span="20">
              <el-form-item label="頭像" class="el-form-item__row">
                <AvatarUploader
                  :photo="formData.photo"
                  :photoUrl="formData.photoUrl"
                  @photo-updated="handlePhoto"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <div class="text-right">
            <el-button size="small" type="primary" @click="createUser">
              確認
            </el-button>
            <el-button size="small" @click="resetFrom">取消</el-button>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
const log = console.log
import is from 'is_js'
import DistrictSelector from '@/components/common/select/DistrictSelector'
import { defaultOption } from './defaultOption'
import QRCodeGenMixin from './_QRCodeGenMixin'
import coordinatePositioning from './_CoordinatePositioning'
import AvatarUploader from './AvatarUploader'
import longTermCareService from '@/API/longTermCareService'

export default {
  mixins: [coordinatePositioning],
  components: { AvatarUploader, DistrictSelector },
  data() {
    return {
      defaultOption,
      formData: {
        areaType: '',
        class: '',
        service: [],
        verification: true,
      },
      teamAvailableServices: [],
    }
  },
  created() {
    this.fetchTeamAvailableService()
  },
  computed: {
    userPreferService() {
      return this.formData.service && this.formData.service.length > 0
        ? this.teamAvailableServices.filter(
            (service) =>
              this.formData.service.indexOf(service.teamServiceId) !== -1,
          )
        : null
    },
  },
  methods: {
    fetchTeamAvailableService() {
      longTermCareService.getTeamAvailableServices().then(({ result }) => {
        this.$set(this, 'teamAvailableServices', result)
      })
    },
    handlePhoto(event) {
      this.formData.photo = event

      if (!event) {
        this.formData.photoUrl = null
      }
    },
    resetFrom() {
      this.formData = {}
      this.back()
    },
    createUser() {
      this.$refs['newUserForm'].validate()

      var formData = new FormData()
      ;[
        'name',
        'contactPerson',
        'areaType',
        'class',
        'deliveryMethod',
        'deliveryMethod',
        'communityShuttleFrequency',
        'firstMobilePhoneNumber',
        'telephoneNumber',
        'secondMobilePhoneNumber',
        'area',
        'identityCode',
        'address',
        'note',
        'authority',
        'verification',
      ].forEach((key) => {
        if (is.existy(this.formData[key])) {
          formData.append(key, this.formData[key])
        }
      })

      if (is.existy(this.formData['gps'])) {
        formData.append('gps', this.formData['gps'].join(','))
      }

      if (this.formData.photo) {
        formData.append(
          'photo',
          this.formData.photo.raw,
          this.formData.photo.name,
        )
      }
      console.log('-------', this.formData)

      longTermCareService
        .addNewUser(formData)
        .then(({ message }) => this.$message.success(message) && this.back())
        .catch(({ data: { error }, message }) =>
          this.$message.error('請輸入必填欄位'),
        )
    },
    back() {
      setTimeout(() => this.$router.go(-1), 700)
    },
  },
}
</script>

<style scoped>
.form-content {
  position: relative;
  max-width: 960px;
  width: 100%;
  margin: auto;
}

.el-form-item {
  width: 48%;
}

.el-form-item__row,
.el-form-item__row .el-form-item__content,
.el-form-item__row .el-textarea,
.el-form-item__row .el-input {
  position: relative;
  width: 100%;
  display: block;
}

.el-form-item__row .el-form-item__label {
  position: absolute;
  top: 0;
}

.el-form-item__row .el-form-item__content {
  width: 100%;
  padding-left: 8em;
}

.block {
  display: block;
}

.border-container {
  border: 2px solid #ebeef5;
  padding: 5px 20px;
  margin-top: 20px;
}

.partial-info-section {
  position: relative;
  margin-bottom: 30px;
}

.partial-info-section .title {
  background: transparent;
  position: relative;
  text-align: center;
}

.partial-info-section .title > span {
  display: inline;
  background: #fff;
  padding: 5px;
  margin: auto;
  z-index: 2;
}

.partial-info-section .title::after {
  display: block;
  content: '';
  top: 50%;
  margin-top: -2px;
  width: 100%;
  position: absolute;
  border: 1px solid #e5e5e5;
  z-index: -1;
}

.table > tbody > tr > td {
  padding-top: 20px;
  padding-bottom: 5px;
  border-top: none;
  border-bottom: 1px solid #ddd;
}

.table > tbody > tr > td:first-child {
  text-align: right;
  width: 300px;
}

.wider-autocomplete {
  width: 400px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/longTermCare/NewUserForm.vue